import React from "react";
import { Alert as AlertAntd, Col, Row, Typography } from "antd";
import { JoinedAlert } from "../../../types";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { CheckCircleIcon } from "@heroicons/react/24/solid";

const { Text } = Typography;

type Props = {
  item: JoinedAlert;
};

const AlertDialog: React.FC<Props> = ({ item }) => {
  const message = item.message;

  const dateString = item?.created_at
    ? new Date(item.created_at).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
    : "";

  return (
    <div key={item?._id} className="alert-dialog-container">
      <AlertAntd
        message={
          <Col>
            <Row>
              <Text strong>{message}</Text>
            </Row>
            {item?.trap_name && (
              <Row>
                <Text>
                  {item?.trap_name} - {item?.device_name}
                </Text>
              </Row>
            )}
            <Row>
              <Text>{`As of ` + dateString} </Text>
            </Row>
          </Col>
        }
        showIcon
        icon={
          item?.severity === "info" ? (
            <CheckCircleIcon className="w-6 h-6 text-[#16A34A]!" />
          ) : (
            <ExclamationTriangleIcon className="w-6 h-6 text-[#F97316]!" />
          )
        }
        className={item?.severity === "info" ? "alert-info" : "alert-warning"}
      />
    </div>
  );
};

export default AlertDialog;
